import { render, staticRenderFns } from "./LoyaltyBonusCard.vue?vue&type=template&id=2bb6741a&scoped=true&"
import script from "./LoyaltyBonusCard.vue?vue&type=script&lang=js&"
export * from "./LoyaltyBonusCard.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyBonusCard.vue?vue&type=style&index=0&id=2bb6741a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6741a",
  null
  
)

export default component.exports